<template>
    <b-container>
        <b-row class="justify-content-md-center">
            <b-col md="12">
                <h2>Eισαγωγή δεδομένων</h2>
                <br>
                <b-button v-b-modal.upload-modal size="sm" variant="outline-primary">
                    Ανέβασμα νέου αρχείου
                    <b-icon icon="upload"></b-icon>
                </b-button>
                <b-modal id="upload-modal" title="Ανέβασμα νέου αρχείου" size="l"
                         ok-title="Εισαγωγή"
                         cancel-title="Ακύρωση"
                         @ok="upload"
                >
                    <Upload ref="uploadComponent"
                            @upload:success="success"
                            @upload:error="error"/>
                </b-modal>
                <br>
                <br>
                <b-card header="Ενεργά" style="overflow: auto">
                    <ListImports ref="activeImports" :is-active="true"/>
                </b-card>
                <br>
                <b-card header="Αρχειοθετημένα" style="overflow: auto">
                    <ListImports ref="archivedImports" :is-archived="true"/>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import ListImports from '@/components/diavImport/ListImports'
import Upload from '@/components/diavImport/UploadForm'

export default {
    name: "DiavImportView",
    components: {
        ListImports,
        Upload
    },
    data() {
        return {
            reloadInterval: null
        }
    },
    created() {
    },
    mounted() {
    },
    computed: {
        role: function () {
            return this.$store.getters.userRole;
        },
    },
    methods: {
        upload: function (bvModalEvt) {
            // prevent close
            bvModalEvt.preventDefault()
            this.$refs.uploadComponent.upload();
        },
        success: function (event) {
            this.$bvModal.hide("upload-modal");
            this.reloadActive();
            this.reloadArchived();
            this.$bvToast.toast("Το αρχείο ανέβηκε με επιτυχία και ξεκίνησε η διαδικασία ενημέρωσης.", {
                title: `Επιτυχία`,
                variant: 'success',
                solid: true
            });
        },
        error: function (event) {
            this.$bvModal.hide("upload-modal");
            this.$bvToast.toast(event, {
                title: `Αδυναμία εισαγωγής αρχείου`,
                variant: 'danger',
                solid: true
            });
        },
        reloadArchived() {
            this.$refs.archivedImports.fetchData();
        },
        reloadActive() {
            this.$refs.activeImports.fetchData();
        },
    }
}
</script>

<style scoped></style>